module.exports = __webpack_public_path__ + "36232f3c3ad5bc382938f1cf76126b61.png";